

import React, { memo } from "react";
import AppIcon from "../../../components/ui/AppIcon";

const ReactionTrigger = memo(({ onClick, isVisible }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        absolute -top-2 -right-2
        w-7 h-7
        flex items-center justify-center
        rounded-full
        bg-app-surface/95 backdrop-blur-md
        border border-border-subtle
        shadow-lg
        transition-all duration-200 ease-out
        ${isVisible
          ? "opacity-100 scale-100 pointer-events-auto"
          : "opacity-0 scale-75 pointer-events-none"
        }
        hover:scale-110 active:scale-95
        hover:bg-white/10
        focus:outline-none focus:ring-2 focus:ring-primary/50
        z-10
      `}
      aria-label="Add reaction"
      title="Add reaction"
    >
      <AppIcon name="Smile" size={14} className="text-text-muted" />
    </button>
  );
});

ReactionTrigger.displayName = "ReactionTrigger";
export default ReactionTrigger;
